import { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

axios.defaults.baseURL = 'https://prodmejatika.bljambi.com';
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;

export default function Header({ setProducts }) {
  const [keyword, setKeyword] = useState('');
  const [usernamePi, setUsernamePi] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    getProducts();

    const cachedUsername = localStorage.getItem('usernamePi');
    if (cachedUsername) setUsernamePi(cachedUsername);

    window.loginPiSDK = loginPiSDK;
  }, []);

  const getProducts = (search = '') => {
    axios
      .get(`/api/produk-publik?search=${search}`)
      .then((res) => {
        const produk = Array.isArray(res.data?.data?.data)
          ? res.data.data.data
          : Array.isArray(res.data?.data)
          ? res.data.data
          : [];

        console.log('✅ Produk dari API:', produk);
        if (setProducts) setProducts(produk);

        if (produk.length === 0) {
          Swal.fire({
            icon: 'info',
            title: 'Produk tidak ditemukan',
            text: 'Coba kata kunci lain, atau pastikan koneksi stabil.',
          });
        }
      })
      .catch((err) => {
        console.error('❌ Gagal ambil produk:', err);
        if (setProducts) setProducts([]);
        Swal.fire({
          icon: 'error',
          title: 'Gagal ambil produk',
          text: 'Pastikan server aktif dan koneksi lancar.',
        });
      });
  };

  const loginPiSDK = async () => {
    console.log('🟢 Tombol Login diklik');

    if (!window?.Pi || typeof window.Pi.authenticate !== 'function') {
      Swal.fire({
        icon: 'warning',
        title: 'Pi Browser diperlukan',
        text: 'Silakan buka aplikasi ini via Pi Browser.',
      });
      return;
    }

    setIsLoggingIn(true);

    try {
      const scopes = ['username', 'payments', 'wallet_address'];
      const auth = await window.Pi.authenticate(scopes, (incomplete) => {
        console.log('🕓 Incomplete Payment:', incomplete);
      });

      const { accessToken, user } = auth;

      if (!user?.username) {
        Swal.fire({
          icon: 'error',
          title: 'Autentikasi gagal',
          text: 'Username Pi tidak tersedia.',
        });
        setIsLoggingIn(false);
        return;
      }

      setUsernamePi(user.username);
      localStorage.setItem('usernamePi', user.username);

      const payload = {
        accessToken,
        user_uid: user.uid,
        username: user.username,
      };

      const res = await axios.post('/api/auth/sdk-login', payload);

      if (res.data?.token) {
        localStorage.setItem('token', res.data.token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;

        console.log('🔐 Token Sanctum disimpan:', res.data.token);

        Swal.fire({
          icon: 'success',
          title: 'Login Berhasil!',
          text: `Selamat datang, ${user.username}`,
          timer: 2000,
          showConfirmButton: false,
        });

        setTimeout(() => {
          window.location.href = '/AccountPage';
          window.location.reload(); // ✅ Paksa reload agar App.jsx ambil token baru
        }, 500);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Login Gagal!',
          text: res.data?.message || 'Token tidak ditemukan.',
        });
      }
    } catch (err) {
      console.error('❌ Login Pi SDK error:', err);
      Swal.fire({
        icon: 'error',
        title: 'Login Gagal!',
        text: err.response?.data?.message || 'Terjadi kesalahan saat autentikasi Pi.',
      });
    } finally {
      setIsLoggingIn(false);
    }
  };

  const logoutPiUser = () => {
    localStorage.removeItem('usernamePi');
    localStorage.removeItem('token');
    setUsernamePi('');

    Swal.fire({
      icon: 'success',
      title: 'Logout Berhasil!',
      text: 'Terima kasih telah menggunakan Nusantara Property!',
      timer: 2000,
      showConfirmButton: false,
    });

    window.location.href = '/';
  };

  return (
    <header className="bg-[#C70039] text-white rounded-xl px-4 py-5 shadow-md">
      <div className="flex justify-between items-center mb-2">
        <h1 className="text-lg font-bold tracking-wide">🏡 Nusantara Property</h1>
        {/* {usernamePi && (
          <span className="italic text-yellow-300 text-sm">👋 {usernamePi}</span>
        )}*/}
      </div>

      <div className="flex gap-2 mb-3">
        <input
          type="text"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          placeholder="Cari properti..."
          className="flex-1 px-4 py-2 rounded-md text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
        />
        <button
          onClick={() => getProducts(keyword)}
          className="bg-yellow-400 text-[#C70039] px-4 py-2 rounded-md font-semibold hover:bg-yellow-500 transition-all"
        >
          Cari
        </button>
      </div>

      {/* <div className="flex justify-end">
        <button
          onClick={usernamePi ? logoutPiUser : loginPiSDK}
          disabled={isLoggingIn}
          className="bg-white text-[#C70039] font-semibold px-4 py-2 rounded-md hover:bg-red-100 transition-all"
        >
          {usernamePi ? 'Logout' : isLoggingIn ? 'Login...' : 'Login Pi'}
        </button>
      </div>*/}
    </header>
  );
}




